import { FC } from 'react';
import AboutComponent from '../../components/about';

const AboutPage: FC = () => {
	return <AboutComponent />;
};

export default AboutPage;
